import { EmployeeLevelEnum } from '../../../types'

export const sortEmployeeLevelsList = (levels: EmployeeLevelEnum[]): EmployeeLevelEnum[] =>
  levels.sort((x, y) => getSortOrderByEmployeeLevel(x, levels) - getSortOrderByEmployeeLevel(y, levels))

export const getSortOrderByEmployeeLevel = (level: EmployeeLevelEnum | null | undefined, employeeLevels: EmployeeLevelEnum[]): number => {
  if (!level || !employeeLevels || !employeeLevels.length) {
    return 0
  }
  return employeeLevels.indexOf(level) + 1
}
